<template>
	<div>
		<a-tooltip placement="top">
			<template slot="title">
				<span>{{ item.Nick }}</span>
			</template>
			<a-avatar :src="$gestios.avatars(item.ID)" />
		</a-tooltip>
	</div>
</template>

<script>
export default {
	name: 'GTableSlotUser',
	props: {
		item: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
